// Einsatzgebiet-Fokus: nur Wien, Niederösterreich und Burgenland werden indexiert.
// Ferne Bundesländer bleiben erreichbar, sind aber noindex und nicht in Sitemap/Linklisten.
export const FOCUS_BUNDESLAENDER = new Set(["wien", "niederoesterreich", "burgenland"]);

export function isFocusLocation(l: { bundeslandSlug: string }): boolean {
  return FOCUS_BUNDESLAENDER.has(l.bundeslandSlug);
}

// Schreib- und Suchvarianten der Fokus-Städte (so wie Kunden tatsächlich suchen).
export const nameVariants: Record<string, string[]> = {
  wien: ["Wien", "Wien und Umgebung", "Wien Umgebung", "alle 23 Wiener Bezirke"],
  "wiener-neustadt": ["Wiener Neustadt", "Wr. Neustadt", "Wr Neustadt", "Bezirk Wiener Neustadt", "Wiener Neustadt-Land", "Wiener Neustadt und Umgebung"],
  baden: ["Baden", "Baden bei Wien", "Bezirk Baden", "Baden und Umgebung"],
  "st-poelten": ["St. Pölten", "Sankt Pölten", "St Pölten", "Bezirk St. Pölten-Land", "St. Pölten und Umgebung"],
  eisenstadt: ["Eisenstadt", "Eisenstadt-Umgebung", "Bezirk Eisenstadt"],
  mattersburg: ["Mattersburg", "Bezirk Mattersburg", "Mattersburg und Umgebung"],
  neunkirchen: ["Neunkirchen", "Neunkirchen NÖ", "Bezirk Neunkirchen", "Neunkirchen und Umgebung"],
  moedling: ["Mödling", "Bezirk Mödling", "Mödling und Umgebung"],
  "bad-voeslau": ["Bad Vöslau", "Bezirk Baden"],
  traiskirchen: ["Traiskirchen", "Bezirk Baden"],
};
